import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { environment } from '../../environments/environment';
import { Richiesta } from '../models/richiesta.model';
import { StoricoRichiesta } from '../models/storico-richiesta.model';
import { StoricoContributo } from '../models/storico-contributo.model';
import { GeneraRichiesteRequest } from '../models/requests/genera-richieste.model';
import { RichiestaStats } from '../models/richiesta-stats.model';
import { DichiarazioneProntaRequest } from '../models/requests/dichiarazione-pronta.model';
import { Intervento } from '../models/intervento.model';
import { CreaVarianteRichiestaDTO } from '../models/requests/crea-variante-richiesta.model';

@Injectable({
  providedIn: 'root'
})
export class RichiesteService {
  private apiUrl = environment.apiUrl + "richiesta"; // URL base per le API delle richieste

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
  ) { }

  getStatsRichieste(anno: number | null): Observable<RichiestaStats> {
    let params = new HttpParams();
    if (anno) {
      params = params.append('anno', anno.toString());
    } else {
      params = params.append('anno', new Date().getFullYear().toString());
    }
    return this.http.get<RichiestaStats>(`${this.apiUrl}/stats`, { params });
  }

  getRichieste(): Observable<Richiesta[]> {
    return this.http.get<Richiesta[]>(`${this.apiUrl}`);
  }

  getRichiesteByEnte(enteEsecutore: string | null): Observable<Richiesta[]> {
    let params = new HttpParams();
    params = params.append('enteEsecutore', enteEsecutore ?? '');
    ////this.logger.info("[RICHIESTE SERVICE] Ente Esecutore PASSATO: " + enteEsecutore);
    this.logger.info('[RICHIESTE SERVICE] Ente Esecutore PASSATO: ' + enteEsecutore);
    return this.http.get<Richiesta[]>(`${this.apiUrl}`, { params });
  }

  getRichiesteFiltrate(stato: string | number | null, anno: string | number | null,  enteEsecutore: string | null): Observable<Richiesta[]> {
    let params = new HttpParams();

    if (anno) {
      //this.logger.info("[RICHIESTE SERVICE] Anno PASSATO: " + anno);
      params = params.append('anno', anno.toString());
    } else {
      //this.logger.info("[RICHIESTE SERVICE] Anno DEFAULT: " + new Date().getFullYear());
     // params = params.append('anno', new Date().getFullYear().toString());
    }

    if (stato) {
      params = params.append('stato', stato);
    }
    if (enteEsecutore) {
      params = new HttpParams();
      params = params.append('enteEsecutore', localStorage.getItem("enteId") ?? '');
    }

    //this.logger.info("[RICHIESTE SERVICE] Params finali: " + params.toString());
    return this.http.get<Richiesta[]>(`${this.apiUrl}`, { params });
  }

  getStoricoRichiesta(richiestaId: number): Observable<StoricoRichiesta[]> {
    return this.http.get<StoricoRichiesta[]>(`${this.apiUrl}/${richiestaId}/storico`);
  }

  getStoricoContributi(richiestaId: number): Observable<StoricoContributo[]> {
    return this.http.get<StoricoContributo[]>(`${this.apiUrl}/${richiestaId}/storico-contributi`);
  }

  generaRichieste(generaRichieste: GeneraRichiesteRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}/genera`, generaRichieste);
  }

  aggiornaRichiesta(richiesta: Richiesta): Observable<Richiesta> {
    return this.http.put<Richiesta>(`${this.apiUrl}/${richiesta.id}/`, richiesta);
  }

  comunicaContributoRichiesta(richiesta: Richiesta): Observable<any> {
    //this.logger.info(richiesta);
    let url = `${this.apiUrl}/${richiesta.id}/comunica-contributo`;
    return this.http.put<Richiesta>(url,  richiesta );
  }

  caricaLettera(idRichiesta: number): Observable<Richiesta> {
    const richiestaDaModificare: Partial<Richiesta> = {
      id: idRichiesta,
      allegatoPdf: true
    };
    return this.http.put<Richiesta>(`${this.apiUrl}/${idRichiesta}`, richiestaDaModificare);
  }

  comunicaFinePreparazione(id: number, note: string): Observable<any> {

    return this.http.put<any>(`${this.apiUrl}/${id}/fine-preparazione`, { note });
  }

  elimina(idRichiesta:number): Observable<any> {
    const httpOptions = {
      reportProgress: true,
    };
    return this.http.delete(this.apiUrl+"/"+idRichiesta, httpOptions);
  }

  dichiaraPronta(id: number, request: DichiarazioneProntaRequest): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${id}/dichiara-pronta`, request);
  }

  modificaRichiesta(richiesta: Richiesta): Observable<Richiesta> {
    return this.http.put<Richiesta>(`${this.apiUrl}/${richiesta.id}`, richiesta);
  }

  finanziaRichiesta(id: number): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${id}/finanzia`, {});
  }

  creaVariante(idRichiesta: number, payload: CreaVarianteRichiestaDTO): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${idRichiesta}/variante`, payload);
  }

  variazioneContributo(idRichiesta: number, importoContributo: number, note: string): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${idRichiesta}/variazione-contributo`, {
      importoContributo,
      note
    });
  }

  getRichiesteByAnno(anno: number): Observable<Richiesta[]> {
    let params = new HttpParams();
    params = params.append('anno', anno.toString());
    return this.http.get<Richiesta[]>(`${this.apiUrl}`, { params });
  }

}
